module.exports = __webpack_public_path__ + "img/product_68.15a00af.webp";